/**
 * NEAR RPC API request types and responses
 * @module
 */
/** @hidden */
export class Provider {
}
